module.exports = __webpack_public_path__ + "static/img/no1-CAR.3302be3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awardTW/img/no1-CAR.png
// module id = gUcn
// module chunks = 1